import { render } from "./Management.vue?vue&type=template&id=06a4b9e0&ts=true"
import script from "./Management.vue?vue&type=script&lang=ts&setup=true"
export * from "./Management.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Orchard/Management.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06a4b9e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06a4b9e0', __exports__)) {
    console.log('reload')
    api.reload('06a4b9e0', __exports__)
  }
  
  module.hot.accept("./Management.vue?vue&type=template&id=06a4b9e0&ts=true", () => {
    console.log('re-render')
    api.rerender('06a4b9e0', render)
  })

}


export default __exports__